import { createContext, useContext, useState, useEffect } from "react";

const YearContext = createContext();

export function YearProvider({ children }) {
  // Default: anno corrente
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(() => {
    const saved = localStorage.getItem("selectedYear");
    return saved ? parseInt(saved) : currentYear;
  });

  // Salva in localStorage quando cambia
  useEffect(() => {
    localStorage.setItem("selectedYear", selectedYear.toString());
  }, [selectedYear]);

  // Genera lista anni (2026-2056)
  const years = [];
  for (let y = 2026; y <= 2056; y++) {
    years.push(y);
  }

  return (
    <YearContext.Provider value={{ selectedYear, setSelectedYear, years }}>
      {children}
    </YearContext.Provider>
  );
}

export function useYear() {
  const context = useContext(YearContext);
  if (!context) {
    throw new Error("useYear must be used within a YearProvider");
  }
  return context;
}
